import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Bg } from "images/svg/aboutBg.svg";

const Header = () => {
  return (
    <Container>
      <Typography
        color={Colors.yellow500}
        size="lg"
        align="center"
        weight="semibold"
        mb="1.2"
        m_size="m"
      >
        About Us
      </Typography>
      <Typography
        size="4.8rem"
        align="center"
        weight="bold"
        mb="3.4"
        m_size="3.6rem"
      >
        Bringing Africa’s Music to the World
      </Typography>
      <Typography
        size="xl"
        m_size="m"
        mb="3"
        color={Colors.grey400}
        lh="2.8rem"
        m_lh="2.4rem"
        dataAos="fade-up"
      >
        Rated Afrika is a dedicated music and video distribution platform built
        to empower African artists, producers, and creators. Designed
        specifically to meet the unique needs of the African music industry,
        Rated Afrika provides an all-in-one solution for content distribution,
        royalty management, and fan engagement. Our mission is simple: to
        amplify African voices and connect creators with audiences around the
        globe.
      </Typography>
      <Typography
        size="xl"
        m_size="m"
        mb="3"
        color={Colors.grey400}
        lh="2.8rem"
        m_lh="2.4rem"
        dataAos="fade-up"
      >
        We believe that African talent deserves fair compensation, recognition,
        and access to the same powerful tools as artists worldwide. With
        features like customizable royalty splits, real-time analytics, and
        localized payment options, Rated Afrika makes it easy for artists to
        share their music and videos while building a sustainable career.
      </Typography>
      <Typography
        size="xl"
        m_size="m"
        color={Colors.grey400}
        lh="2.8rem"
        m_lh="2.4rem"
        dataAos="fade-up"
      >
        Whether you’re an emerging artist or an established name, Rated Afrika
        is your gateway to reaching a global audience, growing your fanbase, and
        earning from your creative work. Join us in shaping the future of
        African music and showcasing the continent's rich talent on the world
        stage.
      </Typography>
      <Background>
        <Bg />
      </Background>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  padding: 9.6rem 14rem;
  margin-bottom: 4rem;
  @media only screen and (max-width: 769px) {
    padding: 4.8rem 3rem;
  }
`;

const Background = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
